import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useUsage } from '../contexts/UsageContext';
import '../css/header.css';

const Header = () => {
  const { user, logout } = useAuth();
  const {
    gifRemaining, gifLimit, gifUsed,
    monthlyImageUsed, monthlyImageLimit,
    loading, refreshUsage
  } = useUsage();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/', label: '카드뉴스 생성' },
    { path: '/card_news_reserve', label: '카드뉴스 예약' },
    { path: '/card_dashboard', label: '카드 대시보드' },
    { path: '/scenario_management', label: '시나리오 관리' },
  ];

  return (
    <header className="app-header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo">
            DB 페르소나 콘텐츠
          </Link>
          <nav className="nav-menu">
            {menuItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        
        <div className="header-right">
          {user && (
            <>
              <div className="usage-widget">
                <div className="usage-item">
                  <span className="usage-label">이미지(월)</span>
                  <span className={`usage-count ${monthlyImageLimit - monthlyImageUsed <= 10 ? 'low' : ''}`}>
                    {monthlyImageUsed}/{monthlyImageLimit}
                  </span>
                </div>
                <div className="usage-divider"></div>
                <div className="usage-item">
                  <span className="usage-label">GIF(일)</span>
                  <span className={`usage-count ${gifRemaining <= 2 ? 'low' : ''}`}>
                    {gifUsed}/{gifLimit}
                  </span>
                </div>
                <button
                  className="usage-refresh-btn"
                  onClick={refreshUsage}
                  disabled={loading}
                  title="사용량 새로고침"
                >
                  <svg
                    className={`refresh-icon ${loading ? 'spinning' : ''}`}
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
                  </svg>
                </button>
              </div>
              <div className="user-menu">
                <span className="user-name">
                  {user.name}님
                </span>
                <div className="user-dropdown">
                  <Link to="/profile" className="dropdown-item">
                    내 프로필
                  </Link>
                  <button onClick={handleLogout} className="dropdown-item logout">
                    로그아웃
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;